import React from "react";
import { Box, Grid2, Stack, Typography } from "@mui/material";

type ProjectCardProps = {
  title: string;
  description: string;
  image: string;
};

export const AcceleratorCard: React.FC<ProjectCardProps> = (props) => {
  const { title, image, description } = props;

  return (
    <Grid2 size={1}>
      <Stack
        width={1}
        height={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        gap={4}
        border={2}
        borderColor="secondary.main"
        borderRadius={8}
        padding={2}
        sx={{
          transition: "all 0.5s ease",

          flexDirection: {
            sm: "row",
            xs: "column",
          },

          gap: {
            md: 4,
            xs: 1,
          },

          "&:hover": {
            borderColor: "primary.main",
            transition: "all 0.5s ease",
          },
        }}
      >
        <Box
          flexBasis="30%"
          border={1}
          borderColor="secondary.main"
          borderRadius={8}
          overflow="hidden"
          sx={{
            width: {
              sm: "unset",
              xs: 1,
            },

            height: {
              xs: 200,
            },
            minHeight: {
              sm: "unset",
              xs: 200,
            },

            overflow: {
              md: "hidden",
              xs: "unset",
            },

            borderRadius: {
              md: 8,
              xs: 4,
            },
            flexBasis: {
              md: "30%",
              sm: "50%",
              xs: "unset",
            },
            "& > img": {
              objectFit: "contain",
            },
          }}
        >
          <img
            src={image}
            alt={title}
            width="100%"
            height="100%"
            loading="lazy"
            decoding="async"
          />
        </Box>

        <Stack
          width={1}
          height={1}
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          gap={1}
        >
          <Typography
            variant="h5"
            color="primary.main"
            sx={{
              fontSize: {
                md: "1.5rem",
                xs: "1.2rem",
              },
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="body2"
            color="textPrimary"
            fontWeight={300}
            sx={{
              fontSize: {
                md: "0.875rem",
                xs: "0.675rem",
              },
            }}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Grid2>
  );
};
